import { render, staticRenderFns } from "./inappropriate.vue?vue&type=template&id=94d9c94e&scoped=true"
import script from "./inappropriate.vue?vue&type=script&lang=js"
export * from "./inappropriate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d9c94e",
  null
  
)

export default component.exports